import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CommercialConditionService {


     //abrir pop up de la home.
    private dataSet = new BehaviorSubject<boolean>(null);

    dataGet = this.dataSet.asObservable();

    setData(mensaje: boolean) {
        this.dataSet.next(mensaje);
    }

}